module.exports = __webpack_public_path__ + "img/02.2344bc64.png";